import { Exception } from '../Exception';

export class GraphLoginException extends Exception {
  constructor(message: string, originalException: unknown) {
    super(message, originalException);
  }
}
